export function maxLinesValidator(value: any, params: any[] | Record<string, any>) {
  const max = (params as Record<string, number>).max

  const lines = (typeof value === "string" ? value : "").split(/\r\n|\n/).filter(v => v.length > 0)
  return lines.length <= max
}
